import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Content = styled.main`
  /* No top padding needed if we have a hero section that goes under the transparent header */
  /* But for generic pages we might need it. Let's make it conditional or just handle it in pages */
  flex-grow: 1;
`;

const Layout = () => {
  return (
    <MainWrapper>
      <Navbar />
      <Content>
        <Outlet />
      </Content>
      <Footer />
    </MainWrapper>
  );
};

export default Layout;
